import React, { useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import 'react-datepicker/dist/react-datepicker.css';
registerLocale('es', es);

const CustomDatePicker = ({ handleChange, value }) => {
  const [startDate, setStartDate] = useState(value);

  const handleOnChange = (value) => {
    const e = {
      target: {
        name: 'date',
        value
      }
    };
    handleChange(e);
    setStartDate(value);
  };

  return (
    <DatePicker
      className="form-control"
      locale="es"
      timeCaption="Hora"
      selected={startDate}
      onChange={(date) => handleOnChange(date)}
      showTimeSelect
      dateFormat="MMMM d, yyyy h:mm aa"
    />
  );
};

export default CustomDatePicker;
